import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton, TextField } from '@mui';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import './details-layout-drawer.scss';

export const AddButton = ({ onAdd }) => (
  <div styleName="edit-row" key="add-option-button">
    <Button color="primary" onClick={onAdd} startIcon={<AddIcon />}>ADD OPTION</Button>
  </div>
);

AddButton.propTypes = {
  onAdd: PropTypes.func
};

const TaskTypeDrawerEditOptions = ({ options, setOptions }) => {
  const handleNameChange = (event, index) => {
    const newOptions = [...options];
    newOptions[index] = {
      ...newOptions[index],
      name: event.target.value
    };
    setOptions(newOptions);
  };

  const onAdd = () => setOptions([...options, { name: '' }]);

  const onRemove = index => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  return (
    <Fragment>
      {options.map((option, index) => (
        <div styleName="edit-row" key={`option-row-${index}`}>
          <div styleName="row-left">
            <TextField
              fullWidth
              size="small"
              aria-label={`Option ${index + 1}`}
              value={option.name}
              onChange={event => handleNameChange(event, index)}
            />
          </div>
          <IconButton
            aria-label={`Remove option ${option.name || index + 1}`}
            data-testid="edit-row-close"
            onClick={() => onRemove(index)}
            style={{ padding: 0 }}
            styleName="row-right row-action"
          >
            <CloseIcon />
          </IconButton>
        </div>
      ))}
      <AddButton onAdd={onAdd} />
    </Fragment>
  );
};

TaskTypeDrawerEditOptions.propTypes = {
  options: PropTypes.array,
  setOptions: PropTypes.func
};

export default TaskTypeDrawerEditOptions;
